const languages = {
    en: 'English',
    cg: 'Crnogorski'
}
const sidebarComponents = [
    // {name: 'constants', label: 'sidebarConstants', icon: 'paperclip'},
    {name: 'customer-types', label: 'sidebarCustomerTypes', icon: 'paperclip'},
    {name: 'contents', label: 'sidebarContents', icon: 'sticky-note'},
    {name: 'menu_items', label: 'sidebarMenuItems', icon: 'stream'},
    // {name: 'municipalities', label: 'Municipalities', icon: 'el-icon-rank' },
    {name: 'distributors', label: 'sidebarDistributors', icon: 'users'},
    {name: 'suppliers', label: 'sidebarSuppliers', icon: 'users'},
    {name: 'rates', label: 'sidebarRates', icon: 'donate'},
    {name: 'translations', label: 'sidebarTranslations', icon: 'clone'},
    {name: 'users', label: 'sidebarUsers', icon: 'user'},
]

const fields = {
    // Suppliers
    suppliers: {
        provider_type_id: {
            default: 2,
            label: 'Provider Type ID',
            description: 'Provider Type Descr',
            validator: value => parseInt(value) === 2
        },
        parent_id: {
            default: null,
            label: 'Distributor ID',
            description: 'Distributor Descr',
            references: 'distributors',
            referenceLabel: 'display_name'
        },
        legal_name: {
            default: null,
            label: 'Legal Name',
            description: 'Legal Name Descr'
        },
        display_name: {
            default: null,
            label: 'Display Name',
            description: 'Display Name Descr'
        },
        city: {
            default: null,
            label: 'City',
            description: 'City Descr'
        },
        zip: {
            default: null,
            label: 'Zip Code',
            description: 'Zip Code Descr'
        },
        address: {
            default: null,
            label: 'Address',
            description: 'Address Descr'
        },
        phone: {
            default: null,
            label: 'Phone',
            description: 'Phone Descr'
        },
        email: {
            default: null,
            label: 'Email',
            description: 'Email Descr'
        },
        web: {
            default: null,
            label: 'Website',
            description: 'Website Descr'
        },
        description: {
            default: null,
            label: 'Description',
            description: 'Description Descr'
        },
        logo: {
            default: null,
            label: 'Logo URL',
            description: 'Logo Descr'
        }
    },
    // Distributors
    distributors: {
        provider_type_id: {
            default: 1,
            label: 'Provider Type ID',
            description: 'Provider Type Descr',
            validator: value => value === 1
        },
        legal_name: {
            default: null,
            label: 'Legal Name',
            description: 'Legal Name Descr'
        },
        display_name: {
            default: null,
            label: 'Display Name',
            description: 'Display Name Descr'
        },
        city: {
            default: null,
            label: 'City',
            description: 'City Descr'
        },
        zip: {
            default: null,
            label: 'Zip Code',
            description: 'Zip Code Descr'
        },
        address: {
            default: null,
            label: 'Address',
            description: 'Address Descr'
        },
        phone: {
            default: null,
            label: 'Phone',
            description: 'Phone Descr'
        },
        email: {
            default: null,
            label: 'Email',
            description: 'Email Descr'
        },
        web: {
            default: null,
            label: 'Website',
            description: 'Website Descr'
        },
        description: {
            default: null,
            label: 'Description',
            description: 'Description Descr'
        },
        logo: {
            default: null,
            label: 'Logo URL',
            description: 'Logo Descr'
        }
    },
    // Rates
    rates: {
        provider: {
            default: null,
            label: 'Supplier ID',
            object: true,
            displayKey: 'data.display_name',
            description: 'Supplier or Distributor ID',
            references: 'suppliers',
            referenceLabel: 'display_name'
        },
        customer_type: {
            default: null,
            label: 'Customer Type ID',
            displayKey: 'name.en',
            object: true,
            description: 'Customer Type Descr'
        },
        season_type: {
            default: 'no_season',
            label: 'Season Type',
            description: 'Season Type Descr'
        },
        metering_point: {
            default: 0,
            label: 'Metering Point',
            description: 'Metering Point Descr'
        },
        billing_capacity_vt: {
            default: 0,
            label: 'Billing Capacity VT',
            description: 'BCVT Descr'
        },
        billing_capacity_mt: {
            default: 0,
            label: 'Billing Capacity MT',
            description: 'BCMT Descr'
        },
        active_energy_vt: {
            default: 0,
            label: 'Active Energy VT',
            description: 'AEVT Descr'
        },
        active_energy_mt: {
            default: 0,
            label: 'Active Energy MT',
            description: 'AEMT Descr'
        },
        reactive_energy_vt: {
            default: 0,
            label: 'Reactive Energy VT',
            description: 'REVT Descr'
        },
        reactive_energy_mt: {
            default: 0,
            label: 'Reactive Energy MT',
            description: 'REMT Descr'
        },
        share_vt: {
            default: 0,
            label: 'Share VT',
            description: 'SVT Descr'
        },
        share_mt: {
            default: 0,
            label: 'Share MT',
            description: 'SMT Descr'
        },
        renewable: {
            default: null,
            label: 'Renewable',
            description: 'Renewable Descr'
        },
        energy_efficiency: {
            default: null,
            label: 'Energy Efficiency',
            description: 'Energy Efficiency Descr'
        },
        meter_type: {
            default: null,
            label: 'Meter Type',
            description: 'Meter Type Descr'
        }
    },
    // Menu Items
    menuItems: {
        section_id: {
            default: null,
            label: 'Section ID',
            description: 'Section ID description'
        },
        order: {
            default: null,
            label: 'Order',
            description: 'Order of menu items'
        }
    },
    // Menu Child Items
    menuChildItems: {
        menu_id: {
            default: null,
            label: 'Menu ID',
            description: 'Menu ID description'
        },
        section_id: {
            default: null,
            label: 'Section ID',
            description: 'Section ID description'
        },
        order: {
            default: null,
            label: 'Order',
            description: 'Order of menu items'
        }
    },
    // Sections
    sections: {
        alias: {
            default: null,
            label: 'Alias',
            description: 'Alias descr'
        },
        name: {
            default: null,
            label: 'Name',
            description: 'Section Name descr',
            multilanguage: true
        }
    },
    // Contents
    contents: {
        section_id: {
            default: null,
            label: 'Section ID',
            description: 'Section id descr',
            references: 'sections',
            referenceLabel: 'alias'
        },
        title: {
            default: null,
            label: 'Title',
            description: 'Title descr',
            multilanguage: true
        },
        subtitle: {
            default: null,
            label: 'Subtitle',
            description: 'Subtitle descr',
            multilanguage: true
        },
        text: {
            default: null,
            label: 'Text',
            description: 'Text descr',
            multilanguage: true
        }
    },
    // Users
    users: {
        name: {
            default: null,
            label: 'Full Name',
            description: 'Name descr'
        },
        email: {
            default: null,
            label: 'Email',
            description: 'Email descr'
        },
        password: {
            default: null,
            label: 'Password',
            description: 'Password',
            type: 'password'
        }
    },
    // Permissions
    permissions: {
        name: {
            default: null,
            label: 'Name',
            description: 'Name descr'
        },
        display_name: {
            default: null,
            label: 'Display Name',
            description: 'Display Name descr'
        },
        description: {
            default: null,
            label: 'Description',
            description: 'Description descr'
        }
    },
    // Roles
    roles: {
        name: {
            default: null,
            label: 'Name',
            description: 'Name descr'
        },
        display_name: {
            default: null,
            label: 'Display Name',
            description: 'Display Name descr'
        },
        description: {
            default: null,
            label: 'Description',
            description: 'Description descr'
        }
    },
    // User roles
    userRoles: {
        user_id: {
            default: null,
            label: 'User ID',
            description: 'User id descr',
            references: 'users',
            referenceLabel: 'name',
            validator: (val) => {
                return val !== null
            }
        },
        role_id: {
            default: null,
            label: 'Role ID',
            description: 'Role id descr',
            references: 'roles',
            referenceLabel: 'display_name',
            validator: (val) => {
                return val !== null
            }
        }
    },
    // Permission roles
    permissionRoles: {
        permission_id: {
            default: null,
            label: 'Permission ID',
            description: 'Permission id descr',
            references: 'permissions',
            referenceLabel: 'name'
        },
        role_id: {
            default: null,
            label: 'Role ID',
            description: 'Role id descr',
            references: 'roles',
            referenceLabel: 'display_name'
        }
    }
}

export default {

    getSidebarComponents() {
        return sidebarComponents
    },
    getLanguages() {
        return languages
    }
}



// WEBPACK FOOTER //
// ./src/model/index.js